import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import VerificationForm from '@/features/auth/components/forms/verification-form'
import { verificationScreenBgImage } from '@/features/auth/constants/image'
import React from 'react'

function VerificationPage() {
    return (
        <AuthBgWrapper image={verificationScreenBgImage}>
            <AuthCardWrapper
                headerTitle='Enter your verification code'
                headerDescription='We’ve sent a verification code to username@domain.com'
            >
                <VerificationForm />
            </AuthCardWrapper>
        </AuthBgWrapper>
    )
}

export default VerificationPage